import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedium = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 1,
			width: 4,
			height: 16,
			rx: 2,
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 9,
			width: 4,
			height: 8,
			rx: 2,
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 5,
			width: 4,
			height: 12,
			rx: 2,
			fill: "#F2B014"
		})
	]
});
const ForwardRef = forwardRef(SvgMedium);
export default ForwardRef;
